import React from 'react';
import DepartmentScreen from './DepartmentScreen';

function PackagingScreen() {
  return (
    <DepartmentScreen
      department="packaging"
      departmentName="Packaging"
      nextDepartment="Completed"
      color="#9C27B0"
    />
  );
}

export default PackagingScreen;